<template>
    <div class="section pt-1 mt-2">
        <div class="wallet-card">
            <div class="wallet-footer">
                <ul class="nav nav-tabs lined" role="tablist">
                    <li class="nav-item">
                        <a class="nav-link" :class="{ active: current_wing === 1 }" data-bs-toggle="tab"
                            href="javascript:void(0)" role="tab" @click="getElectionOfficersList(1)">{{ $t('wisdom') }}</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" :class="{ active: current_wing === 2 }" data-bs-toggle="tab"
                            href="javascript:void(0)" role="tab" @click="getElectionOfficersList(2)">{{ $t('youth') }}</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" :class="{ active: current_wing === 3 }" data-bs-toggle="tab"
                            href="javascript:void(0)" role="tab" @click="getElectionOfficersList(3)">{{ $t('students') }}</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" :class="{ active: current_wing === 4 }" data-bs-toggle="tab"
                            href="javascript:void(0)" role="tab" @click="getElectionOfficersList(4)">{{ $t('women') }}</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" :class="{ active: current_wing === 6 }" data-bs-toggle="tab"
                            href="javascript:void(0)" role="tab" @click="getElectionOfficersList(6)">{{ $t('girls') }}</a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
    <!-- AddElectionOfficerModel -->
    <div class="modal fade action-sheet" id="addElectionOfficerModel" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" v-if="!add_election_officer">{{ $t('edit_election_officer') }}</h5>
                    <h5 class="modal-title" v-if="add_election_officer">{{ $t('add_election_officer') }}</h5>
                </div>
                <div class="modal-body">
                    <div class="action-sheet-content">
                        <Form @submit="addElectionOfficer" :validation-schema="schema">
                            <div class="form-group basic">
                                <label class="label" for="Name">{{ $t('name') }}</label>
                                <Field name="name" type="text" class="form-control" id="name" v-model="name"
                                    placeholder="Enter Name" />
                                <ErrorMessage name="name" class="error-feedback" />
                            </div>
                            <div class="row">
                                <div class="col-5">
                                    <div class="form-group basic">
                                        <div class="input-wrapper">
                                            <label class="label" for="country_code">{{ $t('code') }} <span
                                                    class="text-danger">*</span></label>
                                            <Field as="select" class="form-control custom-select" v-model="country_code"
                                                name="country_code" id="select4">
                                                <option value="91" selected="selected">+91</option>
                                            </Field>
                                        </div>
                                        <ErrorMessage name="country_code" class="error-feedback" />
                                    </div>
                                </div>
                                <div class="col-7">
                                    <div class="form-group basic">
                                        <div class="input-wrapper">
                                            <label class="label" for="mobile">{{ $t('mobile_number') }} <span
                                                    class="text-danger">*</span></label>
                                            <Field name="mobile_number" type="number" id="mobile_number"
                                                class="form-control" placeholder="" v-model="mobile_number"
                                                oninput="javascript: this.value.replace(/[^\d]/g,''); if(this.value.charAt(0) == 0){ this.value = this.value.slice(1, 11); } if(this.value.length > 10) { this.value = this.value.slice(0, 10);} " />
                                            <i class="clear-input">
                                                <ion-icon name="close-circle"></ion-icon>
                                            </i>
                                        </div>
                                        <ErrorMessage name="mobile_number" class="error-feedback" />
                                    </div>
                                </div>
                            </div>
                            <div class="form-group basic">
                                <label class="label" for="wing">{{ $t('wing') }}</label>
                                <div class="input-wrapper">
                                    <Field as="select" class="form-control custom-select" v-model="wing" name="wing"
                                        id="select4">
                                        <option value="1">{{ $t('wisdom') }}</option>
                                        <option value="2">{{ $t('youth') }}</option>
                                        <option value="3">{{ $t('students') }}</option>
                                        <option value="4">{{ $t('women') }}</option>
                                        <option value="6">{{ $t('girls') }}</option>
                                    </Field>
                                </div>
                                <ErrorMessage name="wing" class="error-feedback" />
                            </div>
                            <div class="form-group" v-if="message">
                                <div v-if="message" class="error-feedback">
                                    {{ message }}
                                </div>
                            </div>
                            <div class="form-group basic">
                                <button type="submit" class="btn btn-primary btn-block btn-lg" :disabled="loading"
                                    v-if="editable || add_election_officer">
                                    <span v-show="loading" class="spinner-border spinner-border-sm"></span>
                                    <span>{{ $t('save') }}</span></button>
                                <button type="button" class="btn btn-primary btn-block btn-lg"
                                    v-if="!editable && !add_election_officer"
                                    @click="closeAddElectionOfficerModel">{{ $t('close') }}</button>
                            </div>
                        </Form>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="section-heading">
        <div class="listview-title mt-0">
            {{ $t('election_officers_list') }}
        </div>
        <button type="button" class="btn btn-primary btn-sm me-1 mb-1" @click="electionOfficerAdd" v-if="permissions.add">
            <ion-icon name="add-outline"></ion-icon>
            {{ $t('add') }}
        </button>
    </div>
    <div class="section text-center" v-if="loading_list">
        <div class="spinner-border text-secondary" role="status"></div>
    </div>
    <div class="section text-center" v-if="!loading_list && election_officers_list.length === 0">
        <p class="text-muted">{{ $t('no_election_officers_found') }}</p>
    </div>
    <ul class="listview image-listview inset text" v-if="!loading_list && election_officers_list.length > 0">
        <li v-for="election_officer in election_officers_list" :key="election_officer.id">
            <a href="javascript:void(0)" class="item">
                <img src="assets/img/sample/avatar/avatar1.png" alt="image" class="image">
                <div class="in">
                    <div>
                        <b>
                            {{ election_officer.user ? election_officer.user.name : election_officer.name }}
                        </b>
                        <footer>
                            {{ election_officer.user ? election_officer.user.phone : election_officer.phone }}
                            <span v-if="election_officer.wing">
                                - {{ getWingLabel(election_officer.wing) }}
                            </span>
                        </footer>
                    </div>
                    <div class="card-button dropdown" v-if="permissions.edit || permissions.delete">
                        <button type="button" class="btn btn-link btn-icon" data-bs-toggle="modal"
                            :data-bs-target="'#actionSheetInset' + election_officer.id" @click="showActionModel">
                            <ion-icon name="ellipsis-vertical-outline"></ion-icon>
                        </button>
                    </div>

                    <!-- Default Action Sheet Inset -->
                    <div class="modal fade action-sheet" :id="'actionSheetInset' + election_officer.id" tabindex="-1"
                        role="dialog">
                        <div class="modal-dialog" role="document">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h5 class="modal-title">{{ $t('action') }}</h5>
                                </div>
                                <div class="modal-body">
                                    <ul class="action-button-list" v-if="permissions.edit || permissions.delete">
                                        <li v-if="permissions.edit">
                                            <a href="javascript:void(0)" @click="electionOfficerView(election_officer)"
                                                class="btn btn-list" data-bs-dismiss="modal">
                                                <span>
                                                    <ion-icon name="pencil-outline"></ion-icon> {{ $t('edit') }}
                                                </span>
                                            </a>
                                        </li>
                                        <li v-if="permissions.delete">
                                            <a href="javascript:void(0)"
                                                @click="deleteElectionOfficer(election_officer.id)" class="btn btn-list"
                                                data-bs-dismiss="modal">
                                                <span>
                                                    <ion-icon name="trash-outline"></ion-icon> {{ $t('delete') }}
                                                </span>
                                            </a>
                                        </li>
                                        <li class="action-divider"></li>
                                        <li>
                                            <a href="#" class="btn btn-list text-danger" data-bs-dismiss="modal">
                                                <span>
                                                    <ion-icon name="close-outline"></ion-icon> {{ $t('cancel') }}
                                                </span>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- * Default Action Sheet Inset -->
                </div>
            </a>
        </li>
    </ul>
</template>

<script>
import { Form, Field, ErrorMessage } from "vee-validate";
import * as yup from "yup";
import UserService from "../../services/user.service";
import $ from 'jquery';
export default {
    name: 'Election Officers',
    components: {
        Form,
        Field,
        ErrorMessage,
    },
    data() {
        const nameRegex = /^[a-zA-Z0-9&._-\s]*$/g;
        const schema = yup.object().shape({
            name: yup.string().matches(nameRegex, this.$t('name_regex')).required(this.$t('name_required')),
            mobile_number: yup.string().min(10, this.$t('mobile_number_length')).required(this.$t('mobile_number_required')),
            country_code: yup.string().required(this.$t('country_code_required')),
            wing: yup.string().required(this.$t('wing_required_field')),
        });
        return {
            loading: false,
            loading_list: false,
            message: "",
            country_code: '91',
            mobile_number: '',
            wing: '',
            name: '',
            schema,
            user_level: null,
            election_officers_list: [],
            editable_id: null,
            editable: true,
            add_election_officer: false,
            permissions: [],
            current_wing: 1,
            sub_level: { consol_form_status_level: 0 },
            user_id: null
        };
    },

    computed: {
        currentUser() {
            return this.$store.state.auth.user;
        }
    },
    mounted() {
        if (!this.currentUser) {
            location.replace('/');
        } else {
            this.user_level = parseInt(this.$route.params.sub_level)
            this.user_level_id = parseInt(this.$route.params.id);
            this.getElectionOfficersList(1);
            this.$root.updateParent(this.$t('election_officers'));
        }

        window.onpopstate = function () {
            if ($('body').hasClass('modal-open')) {
                location.reload();
            }
        };
    },
    methods: {
        getElectionOfficersList(wing = null) {
            this.loading_list = true;
            this.current_wing = wing || this.current_wing;

            let data = {
                user_level: this.user_level,
                user_level_id: this.user_level_id,
                wing: this.current_wing
            }

            UserService.authGetRequest('election-officers', data).then(
                (response) => {
                    if (response.data.status == 'success') {
                        this.permissions = response.data.permissions;
                        let officers = response.data.data;
                        if (officers && !Array.isArray(officers)) {
                            officers = [officers];
                        }
                        officers = officers || [];
                        if (wing && Array.isArray(officers)) {
                            officers = officers.filter(officer => {
                                const officerWing = officer.wing;
                                return String(officerWing) === String(wing);
                            });
                        }
                        this.election_officers_list = officers;
                        this.loading_list = false;
                    } else {
                        this.election_officers_list = [];
                        this.loading_list = false;
                    }
                },
                (error) => {
                    this.loading_list = false;
                    this.election_officers_list = [];
                    this.message =
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString();
                }
            );
        },
        electionOfficerView(election_officer) {
            $('#addElectionOfficerModel').modal('show');
            this.wing = election_officer.user ? String(election_officer.user.wing) : String(election_officer.wing);
            this.name = election_officer.user ? election_officer.user.name : election_officer.name || '';
            this.mobile_number = election_officer.user ? election_officer.user.phone : election_officer.phone || '';
            if (this.mobile_number && this.mobile_number.startsWith('+91')) {
                this.mobile_number = this.mobile_number.substring(3);
            } else if (this.mobile_number && this.mobile_number.startsWith('91') && this.mobile_number.length > 10) {
                this.mobile_number = this.mobile_number.substring(2);
            }
            this.country_code = election_officer.user ?
                (election_officer.user.country_code || '91') : '91';
            if (this.country_code && this.country_code.startsWith('+')) {
                this.country_code = this.country_code.substring(1);
            }
            this.editable_id = election_officer.id;
            this.user_id = election_officer.user ? election_officer.user.id : election_officer.user_id;
            this.add_election_officer = false;
            this.editable = true;
            this.message = '';
        },
        electionOfficerAdd() {
            $('#addElectionOfficerModel').modal('show');
            this.wing = String(this.current_wing);
            this.mobile_number = '';
            this.name = '';
            this.country_code = '91';
            this.editable_id = null;
            this.add_election_officer = true;
            this.editable = true;
        },
        addElectionOfficer() {
            this.message = "";
            let data = {
                name: this.name,
                phone: this.mobile_number,
                country_code: this.country_code.startsWith('+') ? this.country_code : '+' + this.country_code,
                wing: this.wing,
                user_level: this.user_level,
                user_level_id: this.user_level_id,
                added_by: this.currentUser.id,
                term: 2
            };
            this.loading = true;
            if (this.editable_id) {
                UserService.authPutRequest(`election-officers/${this.editable_id}`, data).then(
                    (response) => {
                        if (response.data.status == 'success') {
                            $('#addElectionOfficerModel').modal('hide');
                            this.$swal('', response.data.message, 'success');
                            this.getElectionOfficersList(this.current_wing);
                            this.resetForm();
                            this.loading = false;
                        } else if (response.data.status == 'error') {
                            this.message = response.data.message;
                            this.loading = false;
                        } else {
                            this.message = "An unexpected error occurred.";
                            this.loading = false;
                        }
                    },
                    (error) => {
                        this.loading = false;
                        if (error.response && error.response.data && error.response.data.errors) {
                            const errors = error.response.data.errors;
                            let errorMessages = [];
                            Object.keys(errors).forEach(field => {
                                errorMessages.push(`${field}: ${errors[field].join(', ')}`);
                            });
                            this.message = errorMessages.join('; ');
                        } else {
                            this.message = (error.response &&
                                error.response.data &&
                                error.response.data.message) ||
                                error.message ||
                                error.toString();
                        }
                    }
                );
            } else {
                UserService.authPostRequest('election-officers', data).then(
                    (response) => {
                        if (response.data.status == 'success') {
                            $('#addElectionOfficerModel').modal('hide');
                            this.$swal('', response.data.message, 'success');
                            this.getElectionOfficersList(this.current_wing);
                            this.resetForm();
                            this.loading = false;
                        } else if (response.data.status == 'error') {
                            this.message = response.data.message;
                            this.loading = false;
                        } else {
                            this.message = "An unexpected error occurred.";
                            this.loading = false;
                        }
                    },
                    (error) => {
                        this.loading = false;
                        if (error.response && error.response.data && error.response.data.errors) {
                            const errors = error.response.data.errors;
                            let errorMessages = [];
                            Object.keys(errors).forEach(field => {
                                errorMessages.push(`${field}: ${errors[field].join(', ')}`);
                            });
                            this.message = errorMessages.join('; ');
                        } else {
                            this.message = (error.response &&
                                error.response.data &&
                                error.response.data.message) ||
                                error.message ||
                                error.toString();
                        }
                    }
                );
            }
        },
        resetForm() {
            this.name = '';
            this.mobile_number = '';
            this.country_code = '91';
            this.wing = '';
            this.editable_id = null;
            this.user_id = null;
            this.message = '';
            this.add_election_officer = false;
            this.editable = true;
        },
        deleteElectionOfficer(id) {
            this.$swal({
                title: 'Are you sure?',
                text: "You won't be able to revert this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then((result) => {
                if (result.isConfirmed) {
                    UserService.authDeleteRequest('election-officers', { id: id }).then(
                        (response) => {
                            if (response.data.status == 'success') {
                                this.$swal('', response.data.message, 'seccess');
                                this.getElectionOfficersList(this.current_wing);
                            } else {
                                this.$swal('Error!', response.data.message || 'Failed to delete election officer.', 'error');
                            }
                        },
                        (error) => {
                            const errorMessage = (error.response &&
                                error.response.data &&
                                error.response.data.message) ||
                                'Something went wrong while deleting.';
                            this.$swal('Error!', errorMessage, 'error');
                        }
                    );
                }
            });
        },
        closeAddElectionOfficerModel() {
            $('#addElectionOfficerModel').modal('hide');
            this.resetForm();
        },
        getWingLabel(wing) {
            switch (String(wing)) {
                case '1': return 'Wisdom';
                case '2': return 'Youth';
                case '3': return 'Students';
                case '4': return 'Women';
                case '6': return 'Girls';
                default: return '';
            }
        },
        showActionModel() {
        },
    },
};
</script>

<style scoped>
.section-heading {
    padding: 10px 10px 0px 10px;
}

.action-buttons {
    display: flex;
    gap: 5px;
}

.badge {
    cursor: pointer;
}

.nav-link.active {
    background-color: #007bff;
    color: white;
}

.badge-danger {
    background-color: #dc3545;
    color: white;
}

.badge-primary {
    background-color: #007bff;
    color: white;
}

.action-button-list>li {
    min-height: 1px !important;
}

.action-divider {
    height: 1px;
    background-color: #e9ecef;
    margin: 8px 0;
}

.btn-list {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 12px 16px;
    border: none;
    background: transparent;
    color: #333;
    text-decoration: none;
    transition: background-color 0.2s;
}

.btn-list:hover {
    background-color: #f8f9fa;
    text-decoration: none;
    color: #333;
}

.btn-list.text-danger:hover {
    background-color: #f8d7da;
    color: #dc3545;
}

.btn-icon {
    padding: 4px 8px;
    color: #6c757d;
    text-decoration: none;
}

.btn-icon:hover {
    color: #495057;
}
</style>